import { PROMO_CARD } from '../../constants';

export const areAllPromoCards = columns =>
  columns &&
  columns.length > 0 &&
  columns.every(item => item.identifier === PROMO_CARD);
